export default __webpack_public_path__ + "static/ao-logo-2-d18f39ec0887cc4fb065a9d8bf5c5958.png";